import { BodyBasedExpression } from '../Expression.js';
export class ConcatExpression extends BodyBasedExpression {
    evaluate(visitor, localVariables) {
        const source = this.getSource().evaluate(visitor, localVariables);
        const body = this.getBody().evaluate(visitor, localVariables);
        return String(source).concat(String(body));
    }
}
//# sourceMappingURL=ConcatExpression.js.map